
import Axios from 'axios'

const { REACT_APP_USER_URL, REACT_API_ENERGISA_JL } = process.env

const api = Axios.create({
    baseURL: REACT_API_ENERGISA_JL
})

export default api